import { render } from "./AddVariant.vue?vue&type=template&id=4ae19bb1&scoped=true"
import script from "./AddVariant.vue?vue&type=script&lang=js"
export * from "./AddVariant.vue?vue&type=script&lang=js"

import "./AddVariant.vue?vue&type=style&index=0&id=4ae19bb1&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae19bb1"]])

export default __exports__